import { TimelyPlanName } from './TimelyPlanName';
import { PricingRegion } from './PricingRegion';
import { CountryIso } from './Region';

/* eslint-disable key-spacing */
const CurrencyCode = {
  [CountryIso.AUSTRALIA]: 'AUD',
  [CountryIso.GREAT_BRITAIN]: 'GBP',
  [CountryIso.NEW_ZEALAND]: 'NZD',
  [CountryIso.UNITED_STATES]: 'USD',
};
/* eslint-enable key-spacing */

const CurrencySign = {
  DOLLAR: '$',
  POUND: '£',
};

const PricingCalculationMode = {
  STAFF_MULTIPLE: 'STAFF_MULTIPLE',
  SOLO_PLUS_STAFF_MULTIPLE: 'SOLO_PLUS_STAFF_MULTIPLE',
};

export function getPricingMatrix() {
  const pricingMatrix = {
    [PricingRegion.IRL]: {
      pricingRegion: PricingRegion.IRL,
      currencyCode: CurrencyCode[CountryIso.GREAT_BRITAIN],
      sign: CurrencySign.POUND,
      prices: {
        solo: {
          [TimelyPlanName.BASE]: 9,
          [TimelyPlanName.BUILD]: 22,
          [TimelyPlanName.ELEVATE]: 34,
          [TimelyPlanName.INNOVATE]: 39,
        },
        staff: {
          [TimelyPlanName.BUILD]: 22,
          [TimelyPlanName.ELEVATE]: 28,
          [TimelyPlanName.INNOVATE]: 35,
        },
        fixed: {
          [TimelyPlanName.ELEVATE]: 224,
          [TimelyPlanName.INNOVATE]: 284,
        },
        calculationMode: PricingCalculationMode.STAFF_MULTIPLE,
      },
      tag: '',
      sms: 8,
    },
    [PricingRegion.GBR]: {
      pricingRegion: PricingRegion.GBR,
      currencyCode: CurrencyCode[CountryIso.GREAT_BRITAIN],
      sign: CurrencySign.POUND,
      prices: {
        solo: {
          [TimelyPlanName.BASE]: 9,
          [TimelyPlanName.BUILD]: 22,
          [TimelyPlanName.ELEVATE]: 34,
          [TimelyPlanName.INNOVATE]: 39,
        },
        staff: {
          [TimelyPlanName.BUILD]: 22,
          [TimelyPlanName.ELEVATE]: 28,
          [TimelyPlanName.INNOVATE]: 35,
        },
        fixed: {
          [TimelyPlanName.ELEVATE]: 224,
          [TimelyPlanName.INNOVATE]: 284,
        },
        calculationMode: PricingCalculationMode.STAFF_MULTIPLE,
      },
      tag: '',
      sms: 6,
    },
    [PricingRegion.CAN]: {
      pricingRegion: PricingRegion.CAN,
      currencyCode: CurrencyCode[CountryIso.UNITED_STATES],
      sign: CurrencySign.DOLLAR,
      prices: {
        solo: {
          [TimelyPlanName.BASE]: 9,
          [TimelyPlanName.BUILD]: 26,
          [TimelyPlanName.ELEVATE]: 39,
          [TimelyPlanName.INNOVATE]: 47,
        },
        staff: {
          [TimelyPlanName.BUILD]: 24,
          [TimelyPlanName.ELEVATE]: 29,
          [TimelyPlanName.INNOVATE]: 36,
        },
        fixed: {
          [TimelyPlanName.ELEVATE]: 241,
          [TimelyPlanName.INNOVATE]: 300,
        },
        calculationMode: PricingCalculationMode.SOLO_PLUS_STAFF_MULTIPLE,
      },
      tag: '',
      sms: 5,
    },
    [PricingRegion.ROW]: {
      pricingRegion: PricingRegion.ROW,
      currencyCode: CurrencyCode[CountryIso.UNITED_STATES],
      sign: CurrencySign.DOLLAR,
      prices: {
        solo: {
          [TimelyPlanName.BASE]: 9,
          [TimelyPlanName.BUILD]: 26,
          [TimelyPlanName.ELEVATE]: 39,
          [TimelyPlanName.INNOVATE]: 47,
        },
        staff: {
          [TimelyPlanName.BUILD]: 24,
          [TimelyPlanName.ELEVATE]: 29,
          [TimelyPlanName.INNOVATE]: 36,
        },
        fixed: {
          [TimelyPlanName.ELEVATE]: 241,
          [TimelyPlanName.INNOVATE]: 300,
        },
        calculationMode: PricingCalculationMode.SOLO_PLUS_STAFF_MULTIPLE,
      },
      tag: '',
      sms: 8,
    },
    [PricingRegion.USA]: {
      pricingRegion: PricingRegion.USA,
      currencyCode: CurrencyCode[CountryIso.UNITED_STATES],
      sign: CurrencySign.DOLLAR,
      prices: {
        solo: {
          [TimelyPlanName.BASE]: 9,
          [TimelyPlanName.BUILD]: 26,
          [TimelyPlanName.ELEVATE]: 39,
          [TimelyPlanName.INNOVATE]: 47,
        },
        staff: {
          [TimelyPlanName.BUILD]: 24,
          [TimelyPlanName.ELEVATE]: 29,
          [TimelyPlanName.INNOVATE]: 36,
        },
        fixed: {
          [TimelyPlanName.ELEVATE]: 241,
          [TimelyPlanName.INNOVATE]: 300,
        },
        calculationMode: PricingCalculationMode.SOLO_PLUS_STAFF_MULTIPLE,
      },
      tag: '',
      sms: 5,
    },
    [PricingRegion.EUE]: {
      pricingRegion: PricingRegion.EUE,
      currencyCode: CurrencyCode[CountryIso.UNITED_STATES],
      sign: CurrencySign.DOLLAR,
      prices: {
        solo: {
          [TimelyPlanName.BASE]: 9,
          [TimelyPlanName.BUILD]: 26,
          [TimelyPlanName.ELEVATE]: 39,
          [TimelyPlanName.INNOVATE]: 47,
        },
        staff: {
          [TimelyPlanName.BUILD]: 24,
          [TimelyPlanName.ELEVATE]: 29,
          [TimelyPlanName.INNOVATE]: 36,
        },
        fixed: {
          [TimelyPlanName.ELEVATE]: 241,
          [TimelyPlanName.INNOVATE]: 300,
        },
        calculationMode: PricingCalculationMode.SOLO_PLUS_STAFF_MULTIPLE,
      },
      tag: '',
      sms: 8,
    },
    [PricingRegion.NZL]: {
      pricingRegion: PricingRegion.NZL,
      currencyCode: CurrencyCode[CountryIso.NEW_ZEALAND],
      sign: CurrencySign.DOLLAR,
      prices: {
        solo: {
          [TimelyPlanName.BASE]: 9,
          [TimelyPlanName.BUILD]: 42,
          [TimelyPlanName.ELEVATE]: 65,
          [TimelyPlanName.INNOVATE]: 79,
        },
        staff: {
          [TimelyPlanName.BUILD]: 42,
          [TimelyPlanName.ELEVATE]: 53,
          [TimelyPlanName.INNOVATE]: 65,
        },
        fixed: {
          [TimelyPlanName.ELEVATE]: 436,
          [TimelyPlanName.INNOVATE]: 534,
        },
        calculationMode: PricingCalculationMode.SOLO_PLUS_STAFF_MULTIPLE,
      },
      tag: '(exc) GST',
      sms: 10,
    },
    [PricingRegion.AUS]: {
      pricingRegion: PricingRegion.AUS,
      currencyCode: CurrencyCode[CountryIso.AUSTRALIA],
      sign: CurrencySign.DOLLAR,
      prices: {
        solo: {
          [TimelyPlanName.BASE]: 9,
          [TimelyPlanName.BUILD]: 42,
          [TimelyPlanName.ELEVATE]: 65,
          [TimelyPlanName.INNOVATE]: 79,
        },
        staff: {
          [TimelyPlanName.BUILD]: 42,
          [TimelyPlanName.ELEVATE]: 53,
          [TimelyPlanName.INNOVATE]: 65,
        },
        fixed: {
          [TimelyPlanName.ELEVATE]: 436,
          [TimelyPlanName.INNOVATE]: 534,
        },
        calculationMode: PricingCalculationMode.SOLO_PLUS_STAFF_MULTIPLE,
      },
      tag: '(exc) GST',
      sms: 8,
    },
  };

  return pricingMatrix;
}

export function getSmsPricing() {
  const smsPricing = {
    [PricingRegion.NZL]: {
      currency: CurrencyCode[CountryIso.NEW_ZEALAND],
      freeSmsPerStaffPerMonth: {
        [TimelyPlanName.BASE]: 25,
        [TimelyPlanName.BUILD]: 100,
        [TimelyPlanName.ELEVATE]: 150,
        [TimelyPlanName.INNOVATE]: 250,
      },
    },
    [PricingRegion.AUS]: {
      currency: CurrencyCode[CountryIso.AUSTRALIA],
      freeSmsPerStaffPerMonth: {
        [TimelyPlanName.BASE]: 25,
        [TimelyPlanName.BUILD]: 100,
        [TimelyPlanName.ELEVATE]: 200,
        [TimelyPlanName.INNOVATE]: 350,
      },
    },
    [PricingRegion.USA]: {
      currency: CurrencyCode[CountryIso.UNITED_STATES],
      freeSmsPerStaffPerMonth: {
        [TimelyPlanName.BASE]: 25,
        [TimelyPlanName.BUILD]: 100,
        [TimelyPlanName.ELEVATE]: 200,
        [TimelyPlanName.INNOVATE]: 350,
      },
    },
    [PricingRegion.EUE]: {
      currency: CurrencyCode[CountryIso.UNITED_STATES],
      freeSmsPerStaffPerMonth: {
        [TimelyPlanName.BASE]: 25,
        [TimelyPlanName.BUILD]: 100,
        [TimelyPlanName.ELEVATE]: 200,
        [TimelyPlanName.INNOVATE]: 350,
      },
    },
    [PricingRegion.GBR]: {
      currency: CurrencyCode[CountryIso.GREAT_BRITAIN],
      freeSmsPerStaffPerMonth: {
        [TimelyPlanName.BASE]: 25,
        [TimelyPlanName.BUILD]: 100,
        [TimelyPlanName.ELEVATE]: 200,
        [TimelyPlanName.INNOVATE]: 300,
      },
    },
    [PricingRegion.CAN]: {
      currency: CurrencyCode[CountryIso.UNITED_STATES],
      freeSmsPerStaffPerMonth: {
        [TimelyPlanName.BASE]: 25,
        [TimelyPlanName.BUILD]: 100,
        [TimelyPlanName.ELEVATE]: 200,
        [TimelyPlanName.INNOVATE]: 350,
      },
    },
    [PricingRegion.IRL]: {
      currency: CurrencyCode[CountryIso.GREAT_BRITAIN],
      freeSmsPerStaffPerMonth: {
        [TimelyPlanName.BASE]: 25,
        [TimelyPlanName.BUILD]: 100,
        [TimelyPlanName.ELEVATE]: 200,
        [TimelyPlanName.INNOVATE]: 300,
      },
    },
    [PricingRegion.ROW]: {
      currency: CurrencyCode[CountryIso.UNITED_STATES],
      freeSmsPerStaffPerMonth: {
        [TimelyPlanName.BASE]: 25,
        [TimelyPlanName.BUILD]: 100,
        [TimelyPlanName.ELEVATE]: 200,
        [TimelyPlanName.INNOVATE]: 350,
      },
    },
  };

  return smsPricing;
}

/**
 * 05/03/2025
 * The pricing model is pretty straightforward for Solo (price is for one person) and 8-20 staff (fixed price). For 2-7 staff:
 * For everything else it's the solo price plus the per staff rate (For example NZ 2 staff on Elevate is the solo price $62 + $49 for one staff member which equals $111)
 * For GBP once you go above Solo it becomes a flat rate for all staff (For example 1 staff is £21 but 2 staff becomes £42 (2 x £21))
 */
const SOLO_PLUS_STAFF_MULTIPLE = (PricingMatrixCountry) => {
  const country = PricingMatrixCountry;
  return ({ plan, staffCount }) => {
    if (staffCount === 1) {
      return country.prices.solo[plan];
    } else if (staffCount >= 8) {
      return country.prices.fixed[plan];
    } else {
      return (
        country.prices.solo[plan] +
        country.prices.staff[plan] * (staffCount - 1)
      );
    }
  };
};

const STAFF_MULTIPLE = (PricingMatrixCountry) => {
  const country = PricingMatrixCountry;
  return ({ plan, staffCount }) => {
    if (staffCount === 1) {
      return country.prices.solo[plan];
    } else if (staffCount >= 8) {
      return country.prices.fixed[plan];
    } else {
      return country.prices.staff[plan] * staffCount;
    }
  };
};

const calculationMode = {
  SOLO_PLUS_STAFF_MULTIPLE,
  STAFF_MULTIPLE,
};

export const PriceCalculations = (PricingMatrixCountry) => {
  return calculationMode[PricingMatrixCountry.prices.calculationMode](
    PricingMatrixCountry,
  );
};
